/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Benefit_Teams_SsoInputs */



/**
* | output |
* | --- |
* | "SSO integration for seamless access" |
*
* @param {Plan_Gate_Benefit_Teams_SsoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_benefit_teams_sso = /** @type {((inputs?: Plan_Gate_Benefit_Teams_SsoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Benefit_Teams_SsoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SSO-Integration für nahtlosen Zugriff")
	return /** @type {LocalizedString} */ ("SSO integration for seamless access")
});